export enum BENCHMARK_DATASET {
  comptryx = "comptryx",
  mercer = "mercer",
  comprehensive = "comprehensive",
  carta = "carta",
  salary = "salary",
}
